import { z } from 'zod';
/**
 * Consistent error envelope for every API error response.
 *
 * `code` is a stable, machine-readable identifier (e.g. VALIDATION_ERROR,
 * NOT_FOUND, FORBIDDEN, CONFLICT) that clients can branch on without parsing
 * prose. `statusCode`/`error` are retained for HTTP-level compatibility.
 */
export const apiErrorSchema = z.object({
    code: z.string(),
    statusCode: z.number().int(),
    error: z.string(),
    message: z.string(),
    correlationId: z.string().optional(),
    details: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
//# sourceMappingURL=error.js.map